import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = 'https://auth.tiktok-shops.com/api/v2/token/get';

  constructor(private http: HttpClient) {}

  getAccessToken(app_key: string, app_secret: string, auth_code: string): Observable<any> {
    const params = {
      app_key,
      app_secret,
      auth_code,
      grant_type: 'authorized_code'
    };

    return this.http.get(this.apiUrl, { params });
  }
}
